export const SO_NGHE_AN = 489487;
export const SO_DONG_NAI = 489887;

export const LIST_GROUP_BY_AGENT = {
	[SO_NGHE_AN] : 1,
	[SO_DONG_NAI] : 11
};
